module.exports = __webpack_public_path__ + "static/media/calendar-black.6219395b.svg";